module.exports = __webpack_public_path__ + "assets/img/addition_icon.24abd512.svg";